export const LIST_SCHEDULE_EXPECTATION_CYCLES_QUERY_KEY =
  'listAppointmentTypesWithScheduleExpectationCyclesWithinLookahead';
export const LIST_ALL_SCHEDULE_EXPECTATION_CYCLES_QUERY_KEY =
  'listAllAppointmentTypesWithScheduleExpectationCycles';
export const LIST_CHRONOLOGICAL_SCHEDULE_EXPECTATIONS_QUERY_KEY =
  'listChronologicalScheduleExpectations';
export const LIST_CHRONOLOGICAL_APPOINTMENT_TYPES_QUERY_KEY = 'listChronologicalAppointmentTypes';
export const LIST_ACTIVE_CUSTOM_SCHEDULE_EXPECTATIONS_QUERY_KEY =
  'listActiveCustomScheduleExpectations';
export const GET_SCHEDULE_EXPECTATION_QUERY_KEY = 'getScheduleExpectation';
export const GET_SCHEDULE_EXPECTATION_CYCLE_NODES_QUERY_KEY = 'getScheduleExpectationCycleNodes';
export const GET_SCHEDULE_EXPECTATION_END_CYCLE_NODES_QUERY_KEY =
  'getScheduleExpectationEndCycleNodes';
export const GET_SEQUENCE_END_CYCLE_NODES_QUERY_KEY = 'getSequenceEndCycleNodes';
export const GET_SEQUENCE_START_NODES_QUERY_KEY = 'getSequenceStartNodes';
